import dot from "dot-object";

dot.keepArray = true;
export default dot;
